import { render, staticRenderFns } from "./GeoIcon.vue?vue&type=template&id=8791be36&"
import script from "./GeoIcon.vue?vue&type=script&lang=js&"
export * from "./GeoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports